export default __webpack_public_path__ + "link.9e3be156.svg";